import { uploadJobPDF, savePDFUrlToJob } from '../services/pdf-storage';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { calculateTotals } from '../components/cutlist/EstimateTotals';

const BROWN       = [101, 48, 10];
const BROWN_LIGHT = [180, 120, 70];
const WHITE       = [255, 255, 255];
const CREAM       = [252, 249, 245];
const GRAY_LINE   = [220, 215, 208];
const GRAY_TEXT   = [100, 95, 90];
const GRAY_MID    = [150, 145, 140];
const DARK        = [25, 22, 18];
const HEAD_BG     = [242, 236, 228];
const HEAD_TEXT   = [70, 35, 8];

const PAGE_W    = 216;
const PAGE_H    = 279;
const ML        = 14;
const MR        = 14;
const CONTENT_W = PAGE_W - ML - MR;
const HDR_H     = 36;
const FTR_H     = 22;
const FTR_Y     = PAGE_H - FTR_H;
const SAFE_BOTTOM = FTR_Y - 5;

// Total height of the after-table block (terms + thank you + mailing)
const AFTER_TABLE_H = 52;

function drawHeader(doc, estimate) {
  doc.setFillColor(...CREAM);
  doc.rect(0, 0, PAGE_W, HDR_H, 'F');
  doc.setFillColor(...BROWN);
  doc.rect(0, 0, 4, HDR_H, 'F');

  try {
    doc.addImage(
      '/brand/twp-logo.png',
      'PNG', ML + 4, 4, 22, 22
    );
  } catch (e) {}

  doc.setTextColor(...BROWN);
  doc.setFontSize(12); doc.setFont('helvetica', 'bold');
  doc.text('The Window Place LLC', ML + 30, 10);
  doc.setFontSize(6.8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
  doc.text('1300 E 4th Ave  •  Milbank, SD 57252-1547', ML + 30, 15.5);
  doc.text('Phone: (605) 432-1834  •  Fax: (866) 432-1718', ML + 30, 20);
  doc.text('office@thewindowplacellc.com', ML + 30, 24.5);

  doc.setFontSize(25); doc.setFont('helvetica', 'bold'); doc.setTextColor(...BROWN);
  doc.text('ESTIMATE', PAGE_W - MR, 15, { align: 'right' });

  const dateStr = estimate.date
    ? new Date(estimate.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : '';
  doc.setFontSize(7.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
  doc.text('Date: ' + dateStr, PAGE_W - MR, 21.5, { align: 'right' });

  doc.setFillColor(...BROWN);
  doc.rect(0, HDR_H - 1.5, PAGE_W, 1.5, 'F');

  const CY = HDR_H + 5;
  doc.setFontSize(6.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(...BROWN_LIGHT);
  doc.text('PREPARED FOR', ML + 4, CY);
  doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(...DARK);
  doc.text(estimate.customerName || '', ML + 4, CY + 6);
  doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
  let ly = CY + 11.5;
  if (estimate.address) { doc.text(estimate.address, ML + 4, ly); ly += 4.5; }
  const cityState = [estimate.city, estimate.stateZip].filter(Boolean).join(', ');
  if (cityState) { doc.text(cityState, ML + 4, ly); ly += 4.5; }

  const RX = PAGE_W - MR - 82;
  let ry = CY + 6;
  if (estimate.phone) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...BROWN_LIGHT);
    doc.text('Phone:', RX, ry);
    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);
    doc.text(estimate.phone, RX + 15, ry); ry += 5.5;
  }
  if (estimate.email) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...BROWN_LIGHT);
    doc.text('Email:', RX, ry);
    doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);
    doc.text(estimate.email, RX + 13, ry); ry += 5.5;
  }
  if (estimate.jobName) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...BROWN_LIGHT);
    doc.text('Project:', RX, ry);
    doc.setFont('helvetica', 'bolditalic'); doc.setFontSize(7.5); doc.setTextColor(...BROWN);
    doc.text(estimate.jobName, RX + 16, ry); ry += 5.5;
  }

  const ruleY = Math.max(ly, ry) + 3;
  doc.setDrawColor(...GRAY_LINE); doc.setLineWidth(0.3);
  doc.line(ML, ruleY, PAGE_W - MR, ruleY);
  return ruleY + 4;
}

// repName is now passed as a parameter — fixes the scope bug in the original
function drawFooter(doc, pageNum, totalPages, repName) {
  doc.setFillColor(...CREAM); doc.rect(0, FTR_Y, PAGE_W, FTR_H, 'F');
  doc.setFillColor(...BROWN);
  doc.rect(0, FTR_Y, PAGE_W, 1, 'F');
  doc.rect(0, FTR_Y, 4, FTR_H, 'F');

  doc.setDrawColor(...BROWN_LIGHT); doc.setLineWidth(0.35);
  doc.line(ML + 6,  FTR_Y + 10, ML + 66,  FTR_Y + 10);
  doc.line(ML + 76, FTR_Y + 10, ML + 112, FTR_Y + 10);
  doc.setFontSize(6.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_MID);
  doc.text('Customer Signature', ML + 6,  FTR_Y + 14);
  doc.text('Date',               ML + 76, FTR_Y + 14);

  doc.setFontSize(8.5); doc.setFont('helvetica', 'bolditalic'); doc.setTextColor(...BROWN);
  doc.text('Thank you,  ' + (repName || 'A.J. Gingerich'), PAGE_W - MR, FTR_Y + 8, { align: 'right' });
  doc.setFontSize(6.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_MID);
  doc.text('Page ' + pageNum + ' of ' + totalPages, PAGE_W - MR, FTR_Y + 13, { align: 'right' });
  doc.setFontSize(6.5); doc.setTextColor(...BROWN_LIGHT);
  doc.text('The Window Place LLC  •  (605) 432-1834  •  office@thewindowplacellc.com', PAGE_W / 2, FTR_Y + 19, { align: 'center' });
}

// Draw payment terms + notes + thank you + mailing at position y.
// Caller ensures there is enough space before calling.
function drawAfterTableSection(doc, y, terms, estimate, repName, repEmail) {
  if (terms && terms.length > 0) {
    const TERM_BODY_H = terms.length * 7;
    const TERM_TOTAL  = 9 + TERM_BODY_H + 4;
    if (y + TERM_TOTAL < SAFE_BOTTOM) {
      doc.setFillColor(...BROWN); doc.rect(ML, y, CONTENT_W, 9, 'F');
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(...WHITE);
      doc.text('PAYMENT TERMS', ML + 6, y + 6);
      doc.setFillColor(245, 239, 230); doc.rect(ML, y + 9, CONTENT_W, TERM_BODY_H + 4, 'F');
      doc.setDrawColor(...BROWN_LIGHT); doc.setLineWidth(0.3);
      doc.rect(ML, y, CONTENT_W, 9 + TERM_BODY_H + 4, 'S');
      terms.forEach((t, i) => {
        const ty = y + 9 + 5.5 + i * 7;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); doc.setTextColor(...BROWN);
        doc.text(t.label + ':', ML + 6, ty);
        doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
        doc.text(t.term, ML + 28, ty);
      });
      y += TERM_TOTAL + 6;
    }
  }

  if (estimate.comments) {
    const commentLines = doc.splitTextToSize(estimate.comments, CONTENT_W - 12);
    const NOTE_BODY_H  = commentLines.length * 5.5;
    const NOTE_TOTAL   = 9 + NOTE_BODY_H + 6;
    if (y + NOTE_TOTAL < SAFE_BOTTOM) {
      doc.setFillColor(...BROWN); doc.rect(ML, y, CONTENT_W, 9, 'F');
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(...WHITE);
      doc.text('NOTES', ML + 6, y + 6);
      doc.setFillColor(245, 248, 243); doc.rect(ML, y + 9, CONTENT_W, NOTE_BODY_H + 6, 'F');
      doc.setDrawColor(...BROWN_LIGHT); doc.setLineWidth(0.3);
      doc.rect(ML, y, CONTENT_W, 9 + NOTE_BODY_H + 6, 'S');
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(...GRAY_TEXT);
      doc.text(commentLines, ML + 6, y + 16);
      y += NOTE_TOTAL + 6;
    }
  }

  if (y + 36 < SAFE_BOTTOM) {
    doc.setDrawColor(...GRAY_LINE); doc.setLineWidth(0.3);
    doc.line(ML, y, PAGE_W - MR, y); y += 5;

    doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);
    doc.text('Prices for Windows - 1/3 Down Payment', ML, y); y += 4.5;
    doc.text('Doors - 1/2 Down Payment',              ML, y); y += 4.5;
    doc.setFont('helvetica', 'bold');
    doc.text('Balance Upon Completion for all Orders', ML, y); y += 7;

    const thanksY = y;
    doc.setFontSize(8.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(...DARK);
    doc.text('Thank you,', ML, y); y += 5;
    doc.setFont('helvetica', 'bold'); doc.setTextColor(...BROWN);
    doc.text(repName || 'A.J. Gingerich', ML, y); y += 4.5;
    doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
    if (repEmail) doc.text(repEmail, ML, y);

    const rightX = PAGE_W / 2 + 20;
    doc.setFontSize(7.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(...DARK);
    doc.text('MAILING ADDRESS', rightX, thanksY);
    doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
    doc.text('The Window Place LLC', rightX, thanksY + 4.5);
    doc.text('PO BOX 472',          rightX, thanksY + 9);
    doc.text('Milbank, SD 57252',   rightX, thanksY + 13.5);

    y += 8;
    doc.setDrawColor(...GRAY_LINE); doc.setLineWidth(0.3);
    doc.line(ML, y, PAGE_W - MR, y); y += 4;
    doc.setFontSize(7); doc.setFont('helvetica', 'italic'); doc.setTextColor(...GRAY_MID);
    doc.text('Prices subject to change without notice', ML, y);
  }
}

export function generateEstimatePDF(estimate, lineItems, terms, salesRep = {}) {
  const repName  = salesRep.displayName || 'A.J. Gingerich';
  const repEmail = salesRep.email       || 'aj@thewindowplacellc.com';

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' });
  const { subtotal, tax, total } = calculateTotals(lineItems);

  // Draw with placeholder page count — we fix all footers at the very end
  // once we know the real total. This ensures "Page 1 of 2" is always correct.
  const PLACEHOLDER = 99;

  const contentStartY = drawHeader(doc, estimate);
  drawFooter(doc, 1, PLACEHOLDER, repName);

  doc.setFontSize(6.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(...BROWN_LIGHT);
  doc.text('ITEMIZED ESTIMATE', ML + 4, contentStartY);

  let currentPage = 1;

  autoTable(doc, {
    startY: contentStartY + 3,
    head: [['#', 'Qty', 'Description', 'Room / Location', 'Size', 'Unit Price', 'Amount']],
    body: lineItems.map((row, i) => {
      const qty       = parseFloat(row.qty)   || 0;
      const price     = parseFloat(row.price) || 0;
      const lineTotal = qty * price;
      const isAdder   = row.lineType === 'adder' || row.type === 'adder';
      const fmt       = (n) => n > 0 ? '$' + n.toFixed(2) : '';
      if (isAdder) {
        return [
          { content: i + 1 },
          { content: qty > 0 ? String(qty) : '1' },
          { content: row.description || '', colSpan: 3, styles: { halign: 'left', fontStyle: 'italic', textColor: [40, 100, 40] } },
          { content: fmt(price),     styles: { halign: 'right' } },
          { content: fmt(lineTotal), styles: { halign: 'right' } },
        ];
      }
      return [i + 1, qty > 0 ? String(qty) : '1', row.description || '', row.room || '', row.size || '', fmt(price), fmt(lineTotal)];
    }),
    styles: {
      fontSize: 8.5, cellPadding: { top: 4, bottom: 4, left: 5, right: 5 },
      textColor: DARK, lineColor: GRAY_LINE, lineWidth: 0.15,
      overflow: 'linebreak', valign: 'middle', font: 'helvetica',
    },
    headStyles: {
      fillColor: HEAD_BG, textColor: HEAD_TEXT, fontStyle: 'bold', fontSize: 8,
      halign: 'center', lineColor: [180, 140, 100], lineWidth: 0.4,
      minCellHeight: 11, cellPadding: { top: 3.5, bottom: 3.5, left: 5, right: 5 }, overflow: 'hidden',
    },
    alternateRowStyles: { fillColor: [250, 247, 243] },
    columnStyles: {
      0: { cellWidth: 8,      halign: 'center' },
      1: { cellWidth: 16,     halign: 'center' },
      2: { cellWidth: 'auto', halign: 'left'   },
      3: { cellWidth: 35,     halign: 'left'   },
      4: { cellWidth: 28,     halign: 'center' },
      5: { cellWidth: 24,     halign: 'right'  },
      6: { cellWidth: 26,     halign: 'right'  },
    },
    margin: { left: ML, right: MR, bottom: FTR_H + 8 },
    tableLineColor: GRAY_LINE, tableLineWidth: 0.15,
    didDrawPage: (data) => {
      currentPage = data.pageNumber;
      if (data.pageNumber > 1) {
        drawHeader(doc, estimate);
        drawFooter(doc, data.pageNumber, PLACEHOLDER, repName);
      }
    },
    didDrawRow: (data) => {
      if (data.section === 'body') {
        doc.setFillColor(...BROWN_LIGHT);
        doc.rect(ML, data.row.y, 2, data.row.height, 'F');
      }
    },
  });

  let y = doc.lastAutoTable.finalY + 8;

  // ── Totals ────────────────────────────────────────────────────────────────
  if (y + 28 > SAFE_BOTTOM) {
    doc.addPage(); currentPage++;
    drawHeader(doc, estimate);
    drawFooter(doc, currentPage, PLACEHOLDER, repName);
    y = HDR_H + 8;
  }

  const BOX_W = 94;
  const BOX_X = PAGE_W - MR - BOX_W;

  doc.setFillColor(...WHITE); doc.setDrawColor(...GRAY_LINE); doc.setLineWidth(0.2);
  doc.rect(BOX_X, y, BOX_W, 8, 'FD');
  doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
  doc.text('Subtotal', BOX_X + 6, y + 5.5);
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...DARK);
  doc.text('$' + subtotal.toFixed(2), BOX_X + BOX_W - 5, y + 5.5, { align: 'right' });
  y += 8;

  doc.setFillColor(248, 245, 240); doc.rect(BOX_X, y, BOX_W, 8, 'FD');
  doc.setFont('helvetica', 'normal'); doc.setTextColor(...GRAY_TEXT);
  doc.text(' Excise Tax (' + (0.02041 * 100).toFixed(3) + '%)', BOX_X + 6, y + 5.5);
  doc.setFont('helvetica', 'bold'); doc.setTextColor(...DARK);
  doc.text('$' + tax.toFixed(2), BOX_X + BOX_W - 5, y + 5.5, { align: 'right' });
  y += 8;

  doc.setFillColor(...BROWN); doc.rect(BOX_X, y, BOX_W, 12, 'F');
  doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(...WHITE);
  doc.text('TOTAL ESTIMATE', BOX_X + 6, y + 8.5);
  doc.text('$' + total.toFixed(2), BOX_X + BOX_W - 5, y + 8.5, { align: 'right' });
  doc.setDrawColor(...BROWN_LIGHT); doc.setLineWidth(0.5);
  doc.rect(BOX_X, y - 16, BOX_W, 28, 'S');
  y += 16;

  // ── After-table section ───────────────────────────────────────────────────
  // THE KEY FIX: check once if the whole block fits. If yes → draw on this page.
  // If no → add ONE new page then draw. No orphan pages.
  if (y + AFTER_TABLE_H > SAFE_BOTTOM) {
    doc.addPage(); currentPage++;
    drawHeader(doc, estimate);
    drawFooter(doc, currentPage, PLACEHOLDER, repName);
    y = HDR_H + 8;
  }

  drawAfterTableSection(doc, y, terms, estimate, repName, repEmail);

  // ── Fix all page numbers with real total ─────────────────────────────────
  const totalPages = doc.getNumberOfPages();
  for (let p = 1; p <= totalPages; p++) {
    doc.setPage(p);
    drawHeader(doc, estimate);
    drawFooter(doc, p, totalPages, repName);
  }

  // ── Save ──────────────────────────────────────────────────────────────────
  const customer     = (estimate.customerName || 'Customer').replace(/\s+/g, '_');
  const dateStr      = (estimate.date || new Date().toISOString().split('T')[0]).replace(/-/g, '');
  const _blob        = doc.output('blob');
  const _contractNum = (estimate.woNumber || estimate.contractNumber || 'DRAFT').replace(/\s+/g, '_');

  uploadJobPDF(_contractNum, 'estimate', _blob)
    .then(url => savePDFUrlToJob(estimate.twpJobId || null, estimate.id || null, 'estimate', url))
    .catch(e => console.warn('PDF upload skipped:', e));

  doc.save(customer + '_Estimate_' + dateStr + '.pdf');
}